import { Component, Input } from '@angular/core';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

@Component({
  selector: 'app-history-card',
  standalone: true,
  imports: [AnimateOnScrollDirective],
  templateUrl: './history-card.component.html',
})
export class HistoryCardComponent {
  @Input() date: string = '';
  @Input() tempMin: number = 0;
  @Input() tempMax: number = 0;
  @Input() rainfall: number = 0;
}
